import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { WppTypography, WppProgressIndicator, WppInlineMessage } from 'buildingBlocks';
import { dataUploader } from '../style';
import { FileStates, SUBHEADER_TEXT } from '../constants';

const { subHeaderContainer, loader } = dataUploader;

type SubHeaderProps = {
  fileState: FileStates
  error: string | null
};

const SubHeader = ({ fileState, error }: SubHeaderProps) => {
  const subheaderObj = SUBHEADER_TEXT[fileState];
  return (
    <>
      {_.isEqual(fileState, FileStates.uploading)
        ? (<div style={loader}><WppTypography tag="p" type="s-body">Uploading</WppTypography> <WppProgressIndicator variant="circle" width={16} /></div>)
        : (
          <div style={subHeaderContainer}>
            <WppInlineMessage
              type="error"
              size="s"
              message={`${subheaderObj.subheader} ${error ?? parse(subheaderObj.description)}`}
            />
          </div>
        )}
    </>
  );
};

type FilerBannerProps = {
  fileName: string
  onDelete: () => void
  fileState: FileStates
  error: string | null
};

const FileBanner = ({ fileName, onDelete, fileState, error }: FilerBannerProps) => {
  const [showBanner, setShowBanner] = useState<boolean>(!!fileName);
  const successState = _.isEqual(fileState, FileStates.success);
  const nonSuccessState = (fileState in SUBHEADER_TEXT);

  useEffect(() => {
    setShowBanner(!!fileName);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileState]);

  const closeBanner = () => {
    setShowBanner(false);
    onDelete();
  };

  return (
    <>
      {showBanner && (
        <>
          {successState && (
            <WppInlineMessage
              size="l"
              hideCloseBtn={false}
              titleText="File Successfully Uploaded."
              message="Media Optimizations will use the data just uploaded to optimize your campaign."
              type="success"
              onWppClickCloseBtn={closeBanner}
            />
          )}
          {nonSuccessState && <SubHeader fileState={fileState} error={error} />}
        </>
      )}
    </>
  );
};

export default FileBanner;
